// extracted by mini-css-extract-plugin
export default {"card":"SeasonRound_card__TWF13"};